import { ReactComponent as ThinnectLogo } from './../assets/icons/Thinnect_white.svg';
import footerMobilePicture from '../assets/img/footer_login_mobile.png';
import footerMediumPicture from '../assets/img/footer_login_medium.png';
import footerLargePicture from '../assets/img/footer_login_large.png';
import './MainFooter.scss';

type Props = {
	isLoggedIn: boolean;
	isRoomView: boolean;
};

const MainFooter = ({ isLoggedIn, isRoomView }: Props) => {
	return isLoggedIn ? (
		<footer className="mt-auto footer">
			<small className="my-5 d-flex flex-column align-items-center">
				<a
					className="d-flex flex-column flex-sm-row align-items-center text-decoration-none text-reset"
					href="https://thinnect.com"
				>
					<span className="me-0 me-sm-2  ">Solution provided by:</span>
					<ThinnectLogo className="thinnect-footer-logo" />
				</a>
				{process.env.REACT_APP_VERSION && (
					<span className="mt-1">Version: {process.env.REACT_APP_VERSION}</span>
				)}
			</small>
		</footer>
	) : (
		<footer className="footer">
			<picture>
				<source media="(min-width:1200px)" srcSet={footerMediumPicture} />
				<source media="(min-width:576px)" srcSet={footerLargePicture} />
				<img src={footerMobilePicture} alt="Mobile login footer" />
			</picture>
		</footer>
	);
};

export default MainFooter;
